module.exports = __webpack_public_path__ + "stylesheets/global_18e4feb1b056c62f8629723a392a999a.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 153